<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="description"><strong>Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <editor
              formControlName="description"
              id="description2"
						[init]="{
							height: 300,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="season" id="season" type="text" pInputText>
            <label for="season">Season</label>
            @for (validation of validationMessages.season; track validation) {
              <span>
                @if (form1.get('season').hasError(validation.type) && (form1.get('season').dirty || form1.get('season').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="startTime" [timeOnly]="true" [hourFormat]="12" inputId="startTime">
            </p-calendar>
            <label for="startTime">Start Time</label>
            @for (validation of validationMessages.startTime; track validation) {
              <span>
                @if (form1.get('startTime').hasError(validation.type) && (form1.get('startTime').dirty || form1.get('startTime').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="endTime" [timeOnly]="true" [hourFormat]="12" inputId="endTime">
            </p-calendar>
            <label for="endTime">EndT ime</label>
            @for (validation of validationMessages.endTime; track validation) {
              <span>
                @if (form1.get('endTime').hasError(validation.type) && (form1.get('endTime').dirty || form1.get('endTime').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="startTimeDesc" id="startTimeDesc" type="text" pInputText>
            <label for="startTimeDesc">Start Time Description</label>
            @for (validation of validationMessages.startTimeDesc; track validation) {
              <span>
                @if (form1.get('startTimeDesc').hasError(validation.type) && (form1.get('startTimeDesc').dirty || form1.get('startTimeDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="endTimeDesc" id="endTimeDesc" type="text" pInputText>
            <label for="endTimeDesc">End Time Description</label>
            @for (validation of validationMessages.endTimeDesc; track validation) {
              <span>
                @if (form1.get('endTimeDesc').hasError(validation.type) && (form1.get('endTimeDesc').dirty || form1.get('endTimeDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="duration" id="duration" type="text" pInputText>
            <label for="duration">Duration</label>
            @for (validation of validationMessages.duration; track validation) {
              <span>
                @if (form1.get('duration').hasError(validation.type) && (form1.get('duration').dirty || form1.get('duration').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        @if (!activityScheduleId && !activityFeeId) {
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown [options]="activitys" formControlName="activityFeeId" appendTo="body" optionLabel="name"
                optionValue="activityFeeId" (onChange)="selectActivity()" [filter]="true" filterBy="name" [showClear]="false"
                placeholder="Select Activity">
              </p-dropdown>
              <label for="Select Activity">Select Activity</label>
              <span>
                @if (activityFeeIdRequired) {
                  <small class="p-invalid"
                    >Activity is required. (If activity is not here in dropdown, so please add activity first and then add activity-sheduler)
                  </small>
                }
              </span>
            </span>
          </div>
        }

        @if (activityScheduleId) {
          <h5>Upload Images</h5>
        }
        @if (activityScheduleId) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-fileUpload name="files[]" [customUpload]="true" (uploadHandler)="myUploader($event)" multiple="multiple"
                accept=".jpg,.jpeg,.gif" maxFileSize="52428800">
                <ng-template pTemplate="content">
                  @if (uploadedFiles.length) {
                    <ul>
                      @for (file of uploadedFiles; track file) {
                        <li>{{file.name}} - {{file.size}} bytes
                        </li>
                      }
                    </ul>
                  }
                </ng-template>
              </p-fileUpload>
            </span>
          </div>
        }

        @if (!isPicture && activityScheduleId) {
          <h5>Edit Images</h5>
        }
        @if (!isPicture && activityScheduleId) {
          <p-table #pt [value]="pictures" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="pictureId" selectionMode="single"
            [(selection)]="image" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="200"
            [rowsPerPageOptions]="[200,500,1000]" showCurrentPageReport="true"
            currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
            sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
            [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
            <ng-template pTemplate="caption">
              <div  class="d-block text-end">
                <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="unSelectAllPictures()">Unselect All</button>
                <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="selectAllPictures()">Select All</button>
                @if (forDeletePictures.length > 0) {
                  <span>
                    <!--Delete Checked-->
                    <button pButton pRipple class="p-button" style="background-color:red;padding: 0.643rem 0.75rem !important;"
                    (click)="deleteMultiplePictures()">Delete Checked</button>
                  </span>
                }
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                }
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
              <tr>
                <th [ngStyle]="{'width': '50px'}"></th>
                <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
                type="text" (input)="pt.filter($event.target.value, 'pictureId', 'in')"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-image>
              <tr>
                <td>
                  <p-image src="{{image.url}}" alt="{{image.caption}}" width="400" preview="true"></p-image>
                </td>
                <td>
                  {{image.pictureId}}
                </td>
                <td>
                  <!-- <a>
                  <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
                  (click)="onOpenFormEdit(image)"></i>
                </a> -->
                <a (click)="onDelete(image)"><i class="pi pi-times" aria-hidden="true"
                style="color:red; font-size:110%; padding-right:20px;"></i></a>
                <p-checkbox [(ngModel)]="image.checked" [ngModelOptions]="{standalone: true}" [value]="image.checked" (click)="addIntoCheckedList(image)" [binary]="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }

    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (activityScheduleId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Activity Provider</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!activityScheduleId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Activity Provider</button>
            }

            @if (activityScheduleId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Activity Provider</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>